import { action, createAsyncAction } from 'typesafe-actions';
import * as types from './updateCourse.actionTypes';
import { Course } from '@nimbly-technologies/nimbly-common';

export const updateCourse = createAsyncAction(
	types.UPDATE_LMS_COURSE_REQUEST,
	types.UPDATE_LMS_COURSE_SUCCESS,
	types.UPDATE_LMS_COURSE_FAILURE,
)<{ data: Partial<Course> }, undefined, { error: string }>();
